import { Link } from "react-router-dom";
import { Plant as PlantIcon, Star } from "@phosphor-icons/react";
import SmoothImg from "./SmoothImg";
import NewMark from "./NewMark";
import { GraveIcon } from "./GraveIcon";
import { SeverityDots } from "./SeverityMark";
import { fileUrl, focusStyle } from "../lib/api";
import { sevMeta } from "../lib/theme";

export const GRID_CLASS = {
  large: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8",
  compact: "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 sm:gap-4",
  list: "rounded-3xl bg-card overflow-hidden py-1.5 shadow-[0_1px_2px_rgba(0,0,0,0.04),0_8px_24px_-18px_rgba(0,0,0,0.16)] [&>*+*]:border-t [&>*+*]:border-border/50",
};

export default function PlantTile({ plant, favorite, priority = false }) {
  const img = fileUrl(plant.photo_path, 360);
  const dead = plant.status === "deceased";
  const sev = sevMeta(plant.critical_severity);
  return (
    <Link to={`/plants/${plant.id}`} data-testid={`plant-card-${plant.id}`} data-layout="compact"
      className="plant-card group block rounded-3xl bg-card overflow-hidden shadow-[0_1px_2px_rgba(0,0,0,0.04),0_8px_24px_-18px_rgba(0,0,0,0.16)] active:scale-[0.98] transition-transform">
      <div className={`aspect-square bg-muted relative overflow-hidden isolate ${dead ? "grayscale opacity-70" : ""}`}>
        {img ? <SmoothImg src={img} loading={priority ? "eager" : "lazy"} alt={plant.nickname} className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-500" style={focusStyle(plant.photo_focus)} />
          : <div className="h-full w-full flex items-center justify-center"><PlantIcon weight="duotone" className="h-8 w-8 text-muted-foreground/40" /></div>}
        <span className="absolute top-2 left-2 flex gap-1">
          {plant.critical_active && !dead && <span className="h-7 w-7 rounded-full bg-background/90 fine:bg-background/85 fine:backdrop-blur-md inline-flex items-center justify-center" title={`${sev.label} acute event`} data-testid={`plant-card-critical-${plant.id}`}><SeverityDots level={sev.level} color={sev.color} size="sm" /></span>}
          {dead && <span className="h-7 w-7 rounded-full bg-background/90 fine:bg-background/85 fine:backdrop-blur-md inline-flex items-center justify-center"><GraveIcon weight="fill" className="h-3.5 w-3.5 text-[#636366]" /></span>}
        </span>
        {favorite && <Star weight="fill" className="absolute top-2.5 right-2.5 h-4 w-4 text-[#FFCC00] drop-shadow" />}
      </div>
      <div className="px-3 py-2.5 flex items-center gap-1.5 min-w-0">
        <span className={`text-sm font-medium truncate ${dead ? "text-muted-foreground" : ""}`}>{plant.nickname}</span>
        <NewMark plant={plant} className="h-3 w-3" testid={`plant-card-new-${plant.id}`} />
      </div>
    </Link>
  );
}
